/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProviderStateResponse
 */
export interface ProviderStateResponse {
    /**
     * 
     * @type {string}
     * @memberof ProviderStateResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderStateResponse
     */
    errorMessage?: string | null;
}

export function ProviderStateResponseFromJSON(json: any): ProviderStateResponse {
    return ProviderStateResponseFromJSONTyped(json, false);
}

export function ProviderStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderStateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
    };
}

export function ProviderStateResponseToJSON(value?: ProviderStateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'errorMessage': value.errorMessage,
    };
}


